import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../ui/dialog";
import { Preview } from "./preview";

type PreviewDialogProps = {
	open: boolean;
	onOpenChange: (open: boolean) => void;
};

export function PreviewDialog({ open, onOpenChange }: PreviewDialogProps) {
	return (
		<>
			<Dialog open={open} onOpenChange={onOpenChange}>
				<DialogContent className="max-w-full h-[100dvh] p-0 bg-black border-white/10 md:hidden">
					<div className="h-full flex flex-col overflow-hidden">
						<DialogHeader className="shrink-0 flex items-center justify-between p-4 border-b border-white/10 bg-black/90 backdrop-blur-xl">
							<DialogTitle className="text-lg font-semibold text-primary-foreground">
								Event Preview
							</DialogTitle>
						</DialogHeader>
						<div className="flex-1 overflow-hidden">
							<div className="h-full overflow-y-auto">
								<Preview isDialog />
							</div>
						</div>
					</div>
				</DialogContent>
			</Dialog>
		</>
	);
}
